<template lang="pug">
.time-slot-popper
    .time-slot-box(v-if="!isFormSearch")
        .radio-group(@click="timeSlotIdx = 0" style="width: 100%;")
            .radio(:class="{'cur': timeSlotIdx == 0}")
                .circle
                    .black
                span 推荐时段
        p(v-if="timeSlotIdx == 0" style="margin-left: 22px;line-height:30px;color: #282729")
            span(v-for="item in searchTimeSlots" style="width:50%;display:inline-block;") {{item.frequencyName}}(播放{{item.playCount}}次)
    .time-slot-box(style="margin-top: 10px")
        .radio-group(@click="timeSlotIdx = 2" style="width: 100%")
            .radio(:class="{'cur': timeSlotIdx == 2}" style="width: 100%")
                .circle
                    .black
                span 全天轮播（共{{allTimeRanges.length}}个时段，每个时段播放{{allTimeRanges.length ? 300 / allTimeRanges.length : '--'}}次）
    .time-slot-box(style="margin-top: 10px" v-if="!isSmallSn")
        .radio-group(@click="timeSlotIdx = 1;" style="width: 100%")
            .radio(:class="{'cur': timeSlotIdx == 1}" style="width: 100%")
                .circle
                    .black
                span 自选时段和播放次数
                span(style="margin-left: 54px;") 总播放次数：
                    i(style="color: #FF3973") {{totalPlayCount}}
                    i /300
        div(v-if="timeSlotIdx == 1" style="margin-left: 22px;")
            div(v-for="(item, i) in allTimeRanges")
                el-checkbox(@change="selectTimeSlotItem(item)" :value="showTimeSlotIcon(item)" class="check_box")
                .time-slot-item(:class="{time_checked: showTimeSlotIcon(item)}")
                    span {{item.frequencyName}}
                    span(style="margin: 0 15px 0 20px") |
                    span(style="margin-right: 10px") 播放次数:
                    span
                        i.el-icon-remove(class="play_btn" @click="deletePlayNum(item)")
                        span(class="play_num" style="display: inline-block;width: 40px;height: 20px") {{item.playNum || 0}}
                        i.el-icon-circle-plus(class="play_btn" @click="addPlayNum(item)")
                    //- img(src="../assets/choose-icon.png" v-if="showTimeSlotIcon(item)")
    div(style="text-align: center;")
        .submit-btn.white(@click="cancelChooseTimeslot") 取消
        .submit-btn(@click="confirmChooseTimeslot") 确定
</template>

<script>
export default {
  name: "SearchTimeRange",
  props: ["isInit"],
  data() {
    return {
      timeSlotIdx: 0,
      searchTimeSlots: [],
      chooseTimeSlots: [], // 选取时间段 guid 集合
      totalPlayCount: 0,
      allTimeRanges: [],
      dest: {} // 确定选择的数据保存
    };
  },
  computed: {
    showTimeSlotIcon() {
      return item => {
        return this.chooseTimeSlots.indexOf(item.guid) > -1;
      };
    },
    isTimeChooseSelf() {
      // 是否是可以选择非300次
      let selfChoosePlayTimes = this.$store.state.bmap.selfChoosePlayTimes;
      return !!selfChoosePlayTimes;
    },
    payWay() {
      return this.$store.state.order.choosePayWay; // 'cpd', 'cpmL', 'cpmT', 'pkg'
    },
    isSmallSn() {
      // 是否是小屏投放或小屏导入点位
      let name = this.$store.state.order.conditionSearchTypeName;
      return name.toLowerCase().indexOf("smallsn") > -1;
    },
    isFormSearch() {
      return ['/putOrder', '/putCprplus'].indexOf(this.$route.path) > -1
    }
  },
  async created() {
    this.init();
  },
  watch: {
    timeSlotIdx(v) {
      this.totalPlayCount = 0;
      this.allTimeRanges.forEach(el => {
        this.$set(el, "playNum", 0);
      });
      this.chooseTimeSlots = [];
      if (v == 1 && this.$store.state.bmap.chooseTimeSlot.idx == 1) {
        let storeChooseTimeSlot =
          this.$store.state.bmap.chooseTimeSlot.data || [];
        this.chooseTimeSlots = this.allTimeRanges
          .filter(
            el =>
              storeChooseTimeSlot
                .map(ele => ele.frequencyName)
                .indexOf(el.frequencyName) > -1
          )
          .map(el => el.guid);
        this.allTimeRanges.forEach(el => {
          let idx = storeChooseTimeSlot
            .map(ele => ele.frequencyName)
            .indexOf(el.frequencyName);
          if (idx > -1) {
            let playCount = storeChooseTimeSlot[idx].playCount || 0;
            this.$set(el, "playNum", playCount);
            this.totalPlayCount += playCount;
          }
        });
      }
    },
    "$store.state.bmap.recommendTimeSlotData"(list) {
      this.handleRecommendList(list);
    },
    "$store.state.bmap.chooseTimeSlot.idx"(v) {
      this.timeSlotIdx = v;
    }
  },
  methods: {
    async init() {
      if (!this.allTimeRanges || this.allTimeRanges.length == 0)
        await this.getAllTimeList();
      if (this.isFormSearch) {
        // 点位投放 条件搜索时无须展示处理推荐时段
        this.timeSlotIdx = 2; // 条件筛选时 弹出框不显示推荐时段 默认选中全天轮播
        if (this.isInit) this.handleConfirm();
      } else {
        // 渲染推荐时段
        let recommendTimeSlotData = this.$store.state.bmap.recommendTimeSlotData;
        this.handleRecommendList(recommendTimeSlotData);
        // 渲染store数据
        this.timeSlotIdx = this.$store.state.bmap.chooseTimeSlot.idx || 0;

        this.$root.$on("operateResetSetCity", data => {
          this.timeSlotIdx = 0;
          this.$store.commit("setStoreData", { key: "chooseTimeSlot", value: { idx: 0, data: [] } });
        });
      }

      this.$store.commit("setStoreData", { key: ['chooseTimeSlot', 'idx'], value: this.timeSlotIdx });
    },
    async getAllTimeList() {
      let data = this.$store.state.bmap.allTimeRanges;
      if (!data || data.length == 0) {
        await this.$store.dispatch("getTimeRanges");
        data = this.$store.state.bmap.allTimeRanges;
      }
      this.allTimeRanges = data;
    },
    async handleRecommendList(list) {
      if (!this.allTimeRanges || this.allTimeRanges.length == 0)
        await this.getAllTimeList();
      if (list && list.length > 0) {
        let ids = this.allTimeRanges.map(el => el.guid);
        this.searchTimeSlots = list.map(el => {
          let idx = ids.indexOf(el.frequencyTime);
          if (idx > -1)
            el.frequencyName = this.allTimeRanges[idx].frequencyName;
          else el.frequencyName = "未知";
          return el;
        });
      }
    },
    getFrequencyList(type) {
      let frequencyList = [];
      switch (type) {
        case 0: {
          frequencyList = this.searchTimeSlots.map(item => {
            return {
              frequencyName: item.frequencyName,
              frequencyTime: item.frequencyTime,
              playCount: item.playCount,
              slotCount: item.slotCount
            };
          });
          break;
        }
        case 2: {
          frequencyList = this.allTimeRanges.map(item => {
            return {
              frequencyName: item.frequencyName,
              frequencyTime: item.guid,
              playCount: 50,
              slotCount: 1
            };
          });
          break;
        }
        case 1: {
          this.allTimeRanges.forEach(item => {
            if (this.showTimeSlotIcon(item)) {
              frequencyList.push({
                frequencyName: item.frequencyName,
                frequencyTime: item.guid,
                playCount: item.playNum,
                slotCount: (item.playNum - 0) / 50
              });
            }
          });
          break;
        }
      }
      return frequencyList;
    },
    confirmChooseTimeslot() {
      if (this.timeSlotIdx === 1) {
        // 自选
        if (this.isTimeChooseSelf || this.payWay.indexOf("cpm") > -1) {
          // 如果可以自选小于300次的情况
          if (this.totalPlayCount > 300)
            return this.$message.warning("播放次数总数须小于等于300");
          if (this.totalPlayCount < 50)
            return this.$message.warning("播放次数总数须大于50");
        } else {
          if (this.totalPlayCount != 300)
            return this.$message.warning("播放次数总数须等于300");
        }
      }
      this.handleConfirm();
    },
    handleConfirm() {
      document.body.click();
      let data = this.getFrequencyList(this.timeSlotIdx);
      this.dest = { idx: this.timeSlotIdx, data };
      this.$emit("submit", {
        type: this.timeSlotIdx,
        data
      });
    },
    cancelChooseTimeslot() {
      this.timeSlotIdx = this.$store.state.bmap.chooseTimeSlot.idx;
      document.body.click();
    },
    selectTimeSlotItem(item) {
      let idx = this.chooseTimeSlots.indexOf(item.guid);
      if (idx === -1 && !item.playNum) {
        item.playNum = 50;
      } else if (idx > -1) {
        item.playNum = 0;
      }
      this.toggleChooseTimeSlotItem(item);
    },
    addPlayNum(item) {
      if (item.playNum) {
        if (item.playNum < 300) {
          item.playNum = item.playNum + 50;
        }
      } else {
        item.playNum = 50;
      }
      if (this.chooseTimeSlots.indexOf(item.guid) === -1) {
        this.toggleChooseTimeSlotItem(item);
      } else {
        this.counterTotal();
      }
    },
    deletePlayNum(item) {
      if (item.playNum && item.playNum > 0) {
        item.playNum = item.playNum - 50;
      } else {
        item.playNum = 0;
      }
      if (item.playNum > 0) {
        if (this.chooseTimeSlots.indexOf(item.guid) === -1) {
          this.toggleChooseTimeSlotItem(item);
        } else {
          this.counterTotal();
        }
      } else {
        if (this.chooseTimeSlots.indexOf(item.guid) !== -1) {
          this.toggleChooseTimeSlotItem(item);
        } else {
          this.counterTotal();
        }
      }
    },
    counterTotal() {
      let total = 0;
      this.allTimeRanges.forEach(item => {
        if (this.showTimeSlotIcon(item)) {
          let playNum = (item && item.playNum) || 0;
          total = total + playNum;
        }
      });
      this.totalPlayCount = total;
      this.$forceUpdate();
    },
    toggleChooseTimeSlotItem(item) {
      let idx = this.chooseTimeSlots.indexOf(item.guid);
      if (idx > -1) {
        this.chooseTimeSlots.splice(idx, 1);
      } else {
        this.chooseTimeSlots.push(item.guid);
      }
      this.timeSlotIdx = 1;
      this.counterTotal();
    }
  }
};
</script>

<style lang="sass" scoped>
.time-slot-popper
    width: 380px
    margin: 10px
    .time-slot-item
        display: inline-block
        margin: 5px
        padding: 6px 10px 6px 24px
        border: 1px solid #E9E9E9
        color: #999
        text-align: center
        line-height: 28px
        position: relative
        cursor: pointer
        &.choose
            color: #282729
            border: 1px solid #282729
        img
            position: absolute
            top: 0
            right: 0
            width: 12px

    .submit-btn
        width: 80px
        height: 30px
        line-height: 30px
        text-align: center
        margin: 5px
        font-size: 14px
        &.white
            background: #fff
            border: 1px solid #d4d4d4
            color: #282729
.check_box
    margin-right: 12px
    &.is-checked ::v-deep .el-checkbox__inner
        background-color: #FF3973
        border-color: #FF3973
.time_checked
    span
        &:first-child
            color: #282729
    .play_btn
        color: #FF3973
    .play_num
        color: #282729
        font-weight: 600
.radio-group .cur
    color: #282729
</style>
